export function loadVariables(vars)
{
    let keyValues = {};
    if (typeof vars.variables !== 'undefined') {
        keyValues = vars.variables;
    }

    let nodeList = document.querySelectorAll('span[data-cms-var]');
    for (let i = 0; i < nodeList.length; i++) {
        const attrCmsVar = nodeList[i].dataset.cmsVar;
        if (typeof keyValues[attrCmsVar] !== 'undefined') {
            nodeList[i].textContent = keyValues[attrCmsVar];
        } else {
            /**
             * fallback to current value from span[data-cms-value] attribute
             * that generated when cms import
             */
            nodeList[i].textContent = nodeList[i].dataset.cmsValue;
        }
    }
}
